import React from 'react';
import classNames from 'classnames';
import { Button } from '@components/Button';
import { FormData } from './Form.types';
import { useFormLoader } from './Form.hooks';
import './Form.scss';

interface EnquiryTypeFormProps {
  formData: FormData;
  sendBtnLabel?: string;
  isSubmitDisabled?: boolean;
  fieldLoader: ReturnType<typeof useFormLoader>;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
  errors: Record<string, any>;
  formError: string | boolean;
  isSubmitting: boolean;
}

export const Form = ({
  formData,
  sendBtnLabel = 'Send',
  isSubmitDisabled,
  fieldLoader,
  onSubmit,
  errors,
  formError,
  isSubmitting,
}: EnquiryTypeFormProps) => {
  return (
    <form
      className='c-form-submit'
      encType='multipart/form-data'
      method='post'
      onSubmit={(e) => onSubmit(e)}
    >
      {formData?.FormSections?.map(({ SubHeading, FormField = [] }, index) => {
        return (
          <div key={index}>
            {SubHeading && <h3>{SubHeading}</h3>}
            {FormField.map((formField, index) => {
              const name = formField.Name;

              const Field = fieldLoader(formField, index);

              return (
                <div
                  key={index}
                  className={classNames('c-form-field-wrapper', {
                    'c-form-field-wrapper--error': errors[name],
                  })}
                >
                  {Field}
                  {Field && errors[name] && (
                    <span
                      className='c-common-validation c-common-validation-danger'
                      id={`error_${name}`}
                    >
                      {errors[name].message}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
      {!isSubmitting ? (
        <Button
          className='c-send-btn'
          color='primary'
          text={sendBtnLabel}
          disabled={isSubmitDisabled}
        />
      ) : (
        <div className='c-form-spinner'>
          <img className='inline-block' src='/ui/css/img/loader.gif' alt='Loading...' />
        </div>
      )}

      {formError && (
        <div
          className='c-err-msg'
          dangerouslySetInnerHTML={{
            __html: typeof formError === 'string' ? formError : 'Please try again later!',
          }}
        />
      )}
    </form>
  );
};
